import {Validators} from "./validation/Validators.ts";

// Proxy export -- new code should use the new name and import location
export const ValidatorsObj = Validators;
